

import * as api from "../../../../api"; 


  
export const createNewChapter = (APIData) => async (dispatch)=>{
    try {
        const {data } = await api.createNewChapter(APIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const getAllChaptersBySectionId = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAllChaptersBySectionId(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}




export const reArrangeChapters = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.reArrangeChapters(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}



  
export const addEntityToAnyEntity = (APIData) => async (dispatch)=>{
    try {
        const {data } = await api.addEntityToAnyEntity(APIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const getAllContentsBySectionId = (APIData) => async (dispatch)=>{
    try {
        const {data } = await api.getAllContentsBySectionId(APIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}
